import { render } from "./ShareAndEarnModal.vue?vue&type=template&id=c1f24bc8"
import script from "./ShareAndEarnModal.vue?vue&type=script&lang=ts"
export * from "./ShareAndEarnModal.vue?vue&type=script&lang=ts"
script.render = render

export default script